import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { useNavigate } from "react-router-dom";

const block = ({ navigate, video, text, linkedto, number, currentStep, type, sub_type }) => {
  function StrSplit(text) {
    const newText = text.split("\\n");

    return newText;
  }

  return (
    <div
      className={
        type === "com"
          ? "bg-white w-[355px] h-[334px] relative rounded-lg shadow-xl"
          : number === currentStep
          ? "bg-white w-[355px] h-[334px] relative rounded-lg shadow-xl border-2 border-[#169A6A]"
          : number > currentStep
          ? "bg-white w-[355px] h-[334px] relative rounded-lg shadow-xl opacity-[0.6]"
          : "bg-white w-[355px] h-[334px] relative rounded-lg shadow-xl"
      }
    >
      <div className="relative top-[80px] flex justify-center">
        <div>
          {StrSplit(text).map((current) => {
            return (
              <p className="font-Poppins-SemiBold text-2xl text-center" key={current}>
                {current}
              </p>
            );
          })}
        </div>
      </div>

      {number <= currentStep - 1 && !type === "com" && (
        <div className="absolute right-[10px] top-[10px] opacity-60">
          <Checked height={30} />
        </div>
      )}

      {number > currentStep ? (
        <div className="absolute top-[195px] left-[105px] bg-[#169A6A] text-white w-[140px] h-[40px] rounded-lg flex justify-center items-center">
          <p>C'est parti</p>
        </div>
      ) : (
        <button
          onClick={() => {
            navigate(number >= currentStep - 1 ? `/${linkedto}` : null, {
              state: { number: number, sub_type: sub_type },
            });
          }}
          className={
            number > currentStep - 1
              ? "absolute top-[195px] left-[105px] bg-[#169A6A] text-white w-[140px] h-[40px] rounded-lg"
              : "absolute top-[195px] left-[105px] bg-[#BDC4CB] text-white w-[140px] h-[40px] rounded-lg cursor-default"
          }
        >
          C'est parti
        </button>
      )}

      {sub_type == "kit IME" && <div className="font-Poppins-SemiBold text-[#169A6A] text-sm absolute top-[250px] left-[130px] text-center">Coming soon !</div>}

      {video == true ? (
        number > currentStep ? (
          <div className="font-Poppins-SemiBold text-[#169A6A] text-sm absolute top-[250px] left-[130px] text-center">Voir la vidéo</div>
        ) : (
          <button className="font-Poppins-SemiBold text-[#169A6A] text-sm absolute top-[250px] left-[130px] text-center">Voir la vidéo</button>
        )
      ) : null}
    </div>
  );
};

export default block;
